<template>
  <div class="edm-page">
    <h1 class="title">
      EDM营销
    </h1>
    <a-alert
      v-show="emailNum.num !== '' && emailNum.num <= 0"
      type="warning"
      class=""
    >
      <div
        slot="description"
      >
        <i class="iconfont iconicon-test68 fs-warn" />
        当前可用邮件发送量为 {{ emailNum.num }} 封，为保证邮件可正常发送，请及时购买发送量。
        <a
          class="buy-btn fs-blue"
          @click="handleBug"
        >立即购买</a>
      </div>
    </a-alert>
    <a-tabs
      :active-key="activeKey"
      tab-position="top"
      :animated="false"
      @change="tabCallback"
    >
      <a-tab-pane
        key="1"
        tab="邮件"
      />
      <a-tab-pane
        key="2"
        tab="清单"
        force-render
      />
    </a-tabs>
    <router-view />
    <bug-email-modal :visible.sync="showBuyEmailModal" />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import BugEmailModal from './createEmail/BuyModal'

// import MyTitle from '@/components/pc/Title'

export default {
  components: {
    BugEmailModal
    // MyTitle
  },

  data () {
    return {
      activeKey: '1',
      showImportContactFailMessage: false,
      showImportContactFailModal: false,
      showBuyEmailModal: false
    }
  },

  computed: {
    ...mapState('edm', ['emailNum']),
    documentTitle () {
      let { projectname = '', comname = '' } = this.$store.state.baseinfo || {}
      projectname && (projectname = ' - ' + projectname)
      comname && (comname = ' - ' + comname)
      return 'EDM营销' + projectname + comname
    }
  },

  watch: {
    $route: {
      handler (to) {
        let key = '1'
        switch (to.name) {
          case 'EmailList':
            key = '1'
            break
          case 'DetailedList':
          case 'EditContactList':
            key = '2'
            break
          default:
            key = '1'
            break
        }
        this.activeKey = key
      },
      immediate: true
    },
    documentTitle: {
      handler (val) {
        document.title = val
      },
      immediate: true
    }
  },

  async mounted () {
    let chain = await this.fetchEmailNum()
    chain.onSuccess(res => {
      document.title = this.documentTitle
    })
  },

  methods: {
    ...mapActions('edm', ['fetchEmailNum']),
    tabCallback (key) {
      // this.activeKey = key
      let routeName
      if (key === '1') {
        routeName = 'EmailList'
      } else if (key === '2') {
        routeName = 'DetailedList'
      }
      this.$router.push({
        name: routeName
      })
    },
    handleBug () {
      this.showBuyEmailModal = true
    }
  }
}
</script>
<style lang="scss" scoped>
  .edm-page::v-deep {
    margin-bottom: 40px;
    .ant-alert {
      margin-bottom: 24px;
    }
    .ant-alert-message {
      display: none;
    }
    .ant-alert-with-description {
      padding: 8px 15px;
      line-height: 1;
      z-index: 99;
      .ant-alert-description {
        display: inline-block;
        .fs-warn {
          margin-right: 12px;
        }
        .buy-btn {
          margin-left: 24px;
        }
      }
    }
    .ant-tabs-nav-wrap {
      border-top: solid 1px #ebebeb;
    }
    .ant-tabs-bar {
      border-bottom: 0 none;
    }
    .ant-tabs-nav {
      .ant-tabs-tab {
        margin-right: 16px;
        padding: 8px 2px;
        font-size: 18px;
        font-weight: bold;
        line-height: 32px;
      }
    }
  }
</style>
<style lang="scss">
/* .importContactFailModal {
  .anticon {
    display: none;
  }
  .ant-modal-close {
    display: block;
  }
  .ant-modal-confirm-btns {
    display: none;
  }
  .ant-modal-confirm-content > div{
    overflow: auto;
    margin-bottom: 20px;
    padding: 10px;
    max-height: 200px;
    border: solid 1px #dbdbdb;
    border-radius: 4px;
  }
} */
</style>
